import { getApiBaseUrlWithFallback } from '../config/environment';

export const getPotentialMatches = async (minSimilarity = 70) => {
  const baseUrl = await getApiBaseUrlWithFallback();
  const response = await fetch(`${baseUrl}/tools/potential-matches?minSimilarity=${minSimilarity}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-admin-token': 'admin',
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || `HTTP ${response.status}`);
  }

  return response.json();
};

export const linkCompetitor = async (competitorFirstName, competitorLastName, skaterId, updateResults = true) => {
  const baseUrl = await getApiBaseUrlWithFallback();
  const response = await fetch(`${baseUrl}/tools/link-competitor`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-admin-token': 'admin',
    },
    body: JSON.stringify({
      competitorFirstName,
      competitorLastName,
      skaterId,
      updateResults,
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || `HTTP ${response.status}`);
  }

  return response.json();
};

export const addCompetitorAsSkater = async (firstName, lastName, club, level, parentUserId = null) => {
  const baseUrl = await getApiBaseUrlWithFallback();
  const response = await fetch(`${baseUrl}/tools/add-competitor-as-skater`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-admin-token': 'admin',
    },
    body: JSON.stringify({
      firstName,
      lastName,
      club,
      level,
      parentUserId,
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || `HTTP ${response.status}`);
  }

  return response.json();
};

export const dismissMatch = async (competitorFirstName, competitorLastName, skaterId = null, reason = 'not_same_person') => {
  const baseUrl = await getApiBaseUrlWithFallback();
  const response = await fetch(`${baseUrl}/tools/dismiss-match`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-admin-token': 'admin',
    },
    body: JSON.stringify({
      competitorFirstName,
      competitorLastName,
      skaterId,
      reason,
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || `HTTP ${response.status}`);
  }

  return response.json();
};

export const getMatchTypeLabel = (matchType) => {
  switch (matchType) {
    case 'accent_variation':
      return 'Accent/Character Variation';
    case 'same_lastname_similar_first':
      return 'Same Last Name, Similar First';
    case 'nickname_variation':
      return 'Possible Nickname';
    case 'fuzzy_match':
      return 'Similar Names';
    default:
      return matchType;
  }
};

export const getMatchTypeColor = (matchType) => {
  switch (matchType) {
    case 'accent_variation':
      return 'success';
    case 'same_lastname_similar_first':
      return 'warning';
    case 'nickname_variation':
      return 'info';
    case 'fuzzy_match':
      return 'default';
    default:
      return 'default';
  }
};
